exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "p[data-v-010cc6a0]{font-size:15px;text-align:justify}.p[data-v-010cc6a0]{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}", ""]);

// exports
